import React from 'react';
import Typography from 'carbon-react/lib/components/typography';
import Box from 'carbon-react/lib/components/box';

import { FormattedMessage } from '@futrli/localisation';

import * as styles from './settings.scss';

interface Props {
  handleLogoutClick: (event: React.MouseEvent<HTMLElement>) => Promise<void>;
  handleOrganisationsClick: () => void;
  hasUsersPermissions: boolean;
  handleUsersClick: () => void;
}

export const SettingsList = ({
  hasUsersPermissions,
  handleUsersClick,
  handleOrganisationsClick,
  handleLogoutClick
}: Props) => (
  <div>
    <Box display="flex" alignItems="center" height="40px">
      <Typography fontWeight="500" fontSize="14px" color="--colorsUtilityYang080" m={0}>
        <FormattedMessage id="common.settings" defaultMessage="Settings" />
      </Typography>
    </Box>
    <div className={styles.option} onClick={handleOrganisationsClick}>
      <FormattedMessage id="common.organisations" defaultMessage="Organisations" />
    </div>
    {hasUsersPermissions && (
      <div className={styles.option} onClick={handleUsersClick}>
        <FormattedMessage id="common.users" defaultMessage="Users" />
      </div>
    )}
    <div className={styles.option} onClick={handleLogoutClick}>
      <FormattedMessage id="common.log_out" defaultMessage="Log out" />
    </div>
    <div className={styles.divider} />
  </div>
);
